import React, { useEffect } from "react";
import "../index";

const MagazineMainCard: React.FC = () => {
   useEffect(() => {
      const titles = document.querySelectorAll(".madera-title-animated");

      const observer = new IntersectionObserver(
         (entries) => {
            entries.forEach((entry) => {
               if (entry.isIntersecting) {
                  entry.target.classList.add("visible");
               }
            });
         },
         { threshold: 0.3 },
      );

      titles.forEach((title) => observer.observe(title));
      return () => observer.disconnect();
   }, []);

   return (
      <div className="relative w-full flex flex-col md:flex-row justify-center items-center py-20 px-4">
         {/* Texto “Revista Madera de Líder” */}
         <div className="absolute z-20 leading-tight transform -translate-y-1/2 magazine-title">
            <p className="text-white text-sm mb-1 font-inter">Revista</p>
            <h2 className="madera-title madera-title-bold madera-title-animated">Madera</h2>
            <h3 className="madera-title madera-title-regular madera-title-animated">de Líder</h3>
         </div>

         <div className="cover-img md:absolute z-10 w-[220px] sm:w-[280px] md:w-[356.55px] h-[320px] sm:h-[400px] md:h-[462px] rounded overflow-hidden group order-1 md:order-2">
            <a
               href="https://drive.google.com/file/d/1GG6qDQ0Igy1MkqMv-l1hgWuVQxKVxPQm/view"
               target="_blank"
               rel="noopener noreferrer"
               className="block w-full h-full"
            >
               <img
                  src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1791823376/CCED/Portada_Agosto_ozpx4k.png"
                  alt="Portada Agosto 2026"
                  className="w-full h-full object-cover transition duration-300 ease-in-out group-hover:brightness-75"
               />
            </a>
         </div>

         {/* Cuadro informativo */}
         <div className="card-info bg-[#4b4a5a] text-white p-6 sm:p-8 rounded-md w-full max-w-[556px] h-auto md:h-[558px] flex flex-col justify-center z-0 order-2 md:order-1">
            <div className="ml-0 md:ml-[25%] md:py-8">
               <h3 className="text-xl sm:text-2xl font-bold text-[#B9C5D5] font-inter mb-2">Construir para perdurar: Diversidad generacional y visión estratégica</h3>
               <p className="text-sm sm:text-base text-white font-semibold font-inter mb-4 leading-relaxed">
                  Edición núm. 14
               </p>
               <p className="text-sm sm:text-base text-white font-regular font-inter mb-6 ">
               Analizamos el poder de la convivencia entre generaciones en una organización. 
               A través de reflexiones sobre la resiliencia cultural y el liderazgo, el impacto 
               de la empatía en el clima de trabajo, la preservación de los valores familiares 
               frente al cortoplacismo, la gestión responsable de la deuda para buscar la independencia 
               financiera y la profesionalización de la comunicación familiar.{" "}
               </p>
               <p className="text-sm sm:text-base text-white font-semibold font-inter mb-6">Agosto 2026</p>
               <a
                  href="https://drive.google.com/file/d/1GG6qDQ0Igy1MkqMv-l1hgWuVQxKVxPQm/view"
                  download
                  rel="noopener noreferrer"
                  className="bg-[#D8CCB6] rounded-full w-10 h-10 flex items-center justify-center hover:scale-110 transition"
               >
                  <img
                     src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1752602046/CCED/Icon_Button_yekev5.png"
                     alt="Descargar PDF"
                     className="w-5 h-5"
                  />
               </a>
            </div>
         </div>
      </div>
   );
};

export default MagazineMainCard;
